import { useTranslation } from 'react-i18next';
import { toGreekCaps } from '~/lib/i18n/toGreekCaps';
import type { MenuSection } from '~/lib/menu';
import { useSidebarStore } from '~/lib/store/sidebar';
import { SidebarItem } from './sidebar-item';

/** A labeled group of menu items. The label is uppercased (Greek-aware) at render. */
export function SidebarSection({ section }: { section: MenuSection }) {
	const { t } = useTranslation();
	const collapsed = useSidebarStore(s => s.collapsed);
	return (
		<section className="pt-3">
			{!collapsed && (
				<div className="px-2.5 pb-1.5 text-[10px] font-medium tracking-[0.08em] text-foreground-subtle">
					{toGreekCaps(t(section.labelKey))}
				</div>
			)}
			<div className="flex flex-col gap-0.5">
				{section.items.map(item => (
					<SidebarItem key={item.id} item={item} />
				))}
			</div>
		</section>
	);
}
